import type { ReactNode } from 'react';

/** A plain centred line where a simulator screen would be: loading, error, switched off. */
export const Notice = ({ children }: { children: ReactNode }) => (
  <div className="mx-auto max-w-xl text-center text-gray-500">{children}</div>
);

/** The backend kill switch is off: a friendly dead end, not a redirect. */
export const SimulatorUnavailable = () => (
  <Notice>The simulator isn&apos;t available right now. Please check back later.</Notice>
);
